import { Typography as BaseTypography, SxProps, TypographyOwnProps } from '@mui/material';
import React, { ReactNode } from 'react';

interface Props {
  variant?: TypographyOwnProps['variant'];
  fontWeight?: number;
  fontSize?: number;
  sx?: SxProps;
  children?: ReactNode;
  onClick?: () => void;
}

export const Typography: React.FC<Props> = ({ variant, sx, children, fontWeight, fontSize, onClick }) => {
  return (
    <BaseTypography
      onClick={onClick}
      variant={variant}
      fontWeight={fontWeight}
      fontSize={typeof fontSize === 'number' ? `${fontSize / 16}rem` : fontSize}
      sx={{ fontFamily: 'Instrument Sans', ...sx }}
    >
      {children}
    </BaseTypography>
  );
};
